import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "vehicle-report-grid-card vehicle-report-grid-card--spaced" }
const _hoisted_4 = { class: "vehicle-report-grid-card vehicle-report-grid-card--spaced" }
const _hoisted_5 = { class: "vehicle-report-grid-summary-title" }
const _hoisted_6 = { class: "vehicle-report-grid-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ExportButtons, {
      csv: _ctx.exportGridsToExcel,
      pdf: _ctx.exportGridsToPdf,
      xlsx: _ctx.exportGridsToExcel
    }, null, 8, ["csv", "pdf", "xlsx"]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_DxDataGrid, {
                    ref: _ctx.dataGridRef[0],
                    "allow-column-reordering": true,
                    "allow-column-resizing": true,
                    "column-auto-width": true,
                    "column-hiding-enabled": true,
                    class: "vehicle-report-grid",
                    "data-source": _ctx.borderCrossingStore,
                    "hover-state-enabled": true,
                    "remote-operations": _ctx.remoteOperations,
                    "row-alternation-enabled": true,
                    "show-borders": true,
                    "show-column-lines": true,
                    "show-row-lines": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxHeaderFilter, { visible: false }),
                      _createVNode(_component_DxPaging, {
                        "page-index": 0,
                        "page-size": 25
                      }),
                      _createVNode(_component_DxPager, {
                        "allowed-page-sizes": [10, 20, 25],
                        "show-info": true,
                        "show-navigation-buttons": true,
                        "show-page-size-selector": true
                      }),
                      _createVNode(_component_DxFilterRow, { visible: true }),
                      _createVNode(_component_DxColumnFixing, { enabled: true }),
                      _createVNode(_component_DxColumn, {
                        caption: _ctx.$t('components.history.summary.dataGrids.borderCrossing')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.fromCountry'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatCountryCell,
                            "data-field": "from_country"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.toCountry'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatCountryCell,
                            "data-field": "to_country"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.date'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatTimestampCell,
                            "data-field": "timestamp"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.distance'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatDistanceCell,
                            "data-field": "distance"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.place'),
                            "filter-operations": _ctx.allowedOperations,
                            "data-field": "place"
                          }, null, 8, ["caption", "filter-operations"])
                        ]),
                        _: 1
                      }, 8, ["caption"])
                    ]),
                    _: 1
                  }, 8, ["data-source", "remote-operations"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_DxDataGrid, {
                    ref: _ctx.dataGridRef[1],
                    class: "vehicle-report-grid",
                    "data-source": _ctx.delegationStore,
                    "remote-operations": _ctx.remoteOperations,
                    "row-alternation-enabled": true,
                    "show-borders": true,
                    "show-column-lines": true,
                    "show-row-lines": false,
                    style: {"margin-bottom":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxHeaderFilter, { visible: false }),
                      _createVNode(_component_DxPaging, {
                        "page-index": 0,
                        "page-size": 25
                      }),
                      _createVNode(_component_DxPager, {
                        "allowed-page-sizes": [10, 20, 25],
                        "show-info": true,
                        "show-navigation-buttons": true,
                        "show-page-size-selector": true
                      }),
                      _createVNode(_component_DxFilterRow, { visible: true }),
                      _createVNode(_component_DxColumnFixing, { enabled: true }),
                      _createVNode(_component_DxColumn, {
                        caption: _ctx.$t('components.history.summary.dataGrids.workingTimeByCountry')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.country'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatCountryCell,
                            "data-field": "country"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.arrival'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatTimestampCell,
                            "data-field": "arrival_timestamp"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.departure'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatTimestampCell,
                            "data-field": "departure_timestamp"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.timeOfVisit'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatSecondsCell,
                            "data-field": "time"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.driving'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatMinutesCell,
                            "data-field": "drive_time",
                            width: "150"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.otherWork'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatMinutesCell,
                            "data-field": "work_time",
                            width: "150"
                          }, null, 8, ["caption", "filter-operations", "customize-text"]),
                          _createVNode(_component_DxColumn, {
                            "allow-filtering": true,
                            "allow-header-filtering": false,
                            caption: _ctx.$t('components.history.summary.dataGrids.breakAndRest'),
                            "filter-operations": _ctx.allowedOperations,
                            "customize-text": _ctx.formatMinutesCell,
                            "data-field": "rest_time",
                            width: "150"
                          }, null, 8, ["caption", "filter-operations", "customize-text"])
                        ]),
                        _: 1
                      }, 8, ["caption"])
                    ]),
                    _: 1
                  }, 8, ["data-source", "remote-operations"])
                ]),
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('components.history.summary.dataGrids.sum')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DxDataGrid, {
                    ref: _ctx.dataGridRef[2],
                    "data-source": _ctx.store.delegation_by_country_sum,
                    class: "vehicle-report-grid",
                    "row-alternation-enabled": true,
                    "show-borders": true,
                    "show-column-headers": false,
                    "show-column-lines": true,
                    "show-row-lines": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxColumn, {
                        "allow-filtering": true,
                        "allow-header-filtering": false,
                        "filter-operations": _ctx.allowedOperations,
                        "data-field": "country",
                        "customize-text": _ctx.formatCountryCell
                      }, null, 8, ["filter-operations", "customize-text"]),
                      _createVNode(_component_DxColumn, {
                        "allow-filtering": true,
                        "allow-header-filtering": false,
                        "filter-operations": _ctx.allowedOperations,
                        "data-field": "drive_time",
                        "customize-text": _ctx.formatMinutesCell,
                        width: "150"
                      }, null, 8, ["filter-operations", "customize-text"]),
                      _createVNode(_component_DxColumn, {
                        "allow-filtering": true,
                        "allow-header-filtering": false,
                        "filter-operations": _ctx.allowedOperations,
                        "data-field": "work_time",
                        "customize-text": _ctx.formatMinutesCell,
                        width: "150"
                      }, null, 8, ["filter-operations", "customize-text"]),
                      _createVNode(_component_DxColumn, {
                        "allow-filtering": true,
                        "allow-header-filtering": false,
                        "filter-operations": _ctx.allowedOperations,
                        "data-field": "rest_time",
                        "customize-text": _ctx.formatMinutesCell,
                        width: "150"
                      }, null, 8, ["filter-operations", "customize-text"])
                    ]),
                    _: 1
                  }, 8, ["data-source"])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}